var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarksGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 8.13625V8.74958C14.6655 10.1872 14.2 11.586 13.3392 12.7375C12.4785 13.8889 11.2685 14.7312 9.88991 15.1389C8.5113 15.5465 7.03785 15.4975 5.68932 14.9993C4.3408 14.5011 3.18944 13.5803 2.40698 12.3743C1.62452 11.1683 1.25287 9.74163 1.34746 8.30713C1.44205 6.87263 1.99781 5.50714 2.93186 4.4143C3.86591 3.32146 5.1282 2.55984 6.53047 2.24301C7.93274 1.92619 9.39985 2.07114 10.713 2.65625",
    stroke: "#00C950",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.08366L8 10.0837L14.6667 3.41699",
    stroke: "#00C950",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarksGreen);
export default __webpack_public_path__ + "static/media/marks-green.304b047be4fe94c7ab9d03bb1be0343c.svg";
export { ForwardRef as ReactComponent };